class LSGWarrantyListing extends HTMLElement {
    constructor() {
        super();
        const form = this.querySelector('.js-warranty-form');
        this.bindEvents(form);
    }


    bindEvents(form) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const id = form.querySelector('input[name="id"]').value;
            const quantity = form.querySelector('input[name="quantity"]').value;
            const submitBtn = form.querySelector('.lsg-warranty-listing__btn-submit');

            const data = {
                id: id,
                quantity: quantity
            };

            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            };

            fetch(window.location.origin + '/cart/add', options)
            .then(response => {
                if (response.status === 200) {
                    submitBtn.querySelector('span').innerHTML = 'Added';
                    this.updateCart();
                }
            });

        });
    }

    updateCart() {
        // Assuming you have an element with id "targetElement" where you want to load the content
        var targetElement = document.querySelectorAll('.cart-count-bubble');
    
        // Make a fetch request to fetch the content from the server
        fetch(window.location)
            .then((response) => {
                // Extract the HTML content from the response
                return response.text();
            })
            .then((html) => {
                // Create a temporary div element
                var tempDiv = document.createElement('div');
                // Set the innerHTML of the tempDiv with the fetched HTML content
                tempDiv.innerHTML = html;
    
                // Extract the specific element(s) you need
                var specificElement = tempDiv.querySelector('.cart-count-bubble');
    
                // Check if the specific element is found
                if (specificElement) {
                    targetElement.forEach(el => {
                        // Clear the targetElement
                        el.innerHTML = '';
                        // Append the specific element to the targetElement
                        el.insertAdjacentHTML(
                            'afterbegin',
                            specificElement.innerHTML,
                        );
                    })
                }
            });
    }
}

customElements.define('warranty-listing', LSGWarrantyListing);